export const QA = 'qa';
export const COURSE = 'course';
export const LIVE_TOPIC = 'live_topic';
export const GROUP_PASS = 'group_pass';



// WEBPACK FOOTER //
// ./app/constants/productType.js